import { AppEvent } from './../../../app_bus/app-event';
export class ToneAddedEvent extends AppEvent {
    constructor() {
        super("Added tone entry");
    }
}
//# sourceMappingURL=tone-added-event.js.map